import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="aspectly:flex aspectly:min-h-screen aspectly:flex-col aspectly:items-center aspectly:justify-center aspectly:gap-4 aspectly:bg-surface aspectly:px-6">
      <span className="material-symbols-outlined aspectly:text-on-surface-variant/40 aspectly:text-6xl">
        search_off
      </span>
      <h1 className="aspectly:font-headline aspectly:text-2xl aspectly:font-bold aspectly:text-on-surface">
        Page not found
      </h1>
      <p className="aspectly:text-sm aspectly:text-on-surface-variant">
        This URL is not valid. Open a workspace from{' '}
        <Link to="/choose-org" className="aspectly:text-primary aspectly:font-semibold aspectly:hover:underline">
          workspace selection
        </Link>
        .
      </p>
    </div>
  );
}
